import React, { useRef, useState } from 'react'
import Banner from './Banner';
import { ReactComponent as SuccessIcon } from '../../assets/icons/success.svg';
import Webcam from "react-webcam";

const BrokerVerification = ({ setChannelPartner }) => {

    return (
        <div className=' mx-auto overflow-auto '>
            <div className='!w-full'>
                <Banner />
            </div>
            <div className='flex items-center flex-col justify-center !my-6 !py-12 bg-white rounded-xl'>
                <SuccessIcon className='' />
                {/* <input accept=”image/*” id=”icon-button-file” type=”file” capture=”environment” /> */}
                <h3 className='!mt-9 text-xl sm:text-4xl text-center font-semibold'>Your visit will be handled with Propacity team !</h3>
                <p className='text-lg sm:text-2xl !mt-4 text-center'>Your Site Visit have been registered Successfully.</p>
                <button className='w-full sm:w-1/2 sm:h-[80px] !mt-20 text-lg sm:!text-2xl font-semibold rounded-xl py-2 sm:!py-3.5 bg-blue-900 text-white' onClick={() => {
                    window.location.reload()
                    setChannelPartner('1')
                }}>Register New Customer</button>
            </div>
        </div>
    )
}

export default BrokerVerification